import React, { useEffect, useContext } from "react";
import { StoreContext } from "../../Context/StoreContext";
import Carousel from "react-multi-carousel";
import { useState } from "react";
import { getCurrentHappeningEvent } from "../../services/eventService";
import moment from "moment-timezone";
import EventHappeningCard from "../../VibehutUI/Card/Timesensitive/EventHappeningCard";
import { Event } from "../../types";

interface Props {
  sliderWidth: number;
}

function CurrentlyHappening({ sliderWidth }: Props) {
  const { state } = useContext(StoreContext);
  const [events, setEvents] = useState([]);
  const zone = moment.tz.guess();

  const {
    auth: { user },
  } = state;
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 3,
    },
    desktop: {
      breakpoint: { max: 3000, min: 769 },
      items: 2,
    },
    tablet: {
      breakpoint: { max: 768, min: 641 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
    },
  };

  const getAutoOrganizedEventsFun = async () => {
    await getCurrentHappeningEvent(user?.token, zone)
      .then((res) => {
        setEvents(res.data);
      })
      .catch(() => {
        setEvents([]);
      });
  };

  useEffect(() => {
    if (user?._id) {
      getAutoOrganizedEventsFun();
    }
  }, [user?._id]);

  function splitArrayIntoChunks(chunkSize = 2) {
    const result = [];
    for (let i = 0; i < events.length; i += chunkSize) {
      result.push(events.slice(i, i + chunkSize));
    }
    return result;
  }

  const chunkEvents = splitArrayIntoChunks();
  return (
    <>
      {events?.length > 0 && (
        <div className="relative" style={{ width: sliderWidth }}>
          <div className="pt-8">
            <div className="px-2">
              <p className="font-bold md:text-2xl text-xl text-darkNight dark:text-frescoWhite">
                Time Sensitive
              </p>
              <p className="text-lg text-darkGray">
                Your events that that have started or are happening soon
              </p>
            </div>

            <div className="pt-7 ">
              <div className="hidden md:block">
                <div className="grid md:grid-cols-2 4xl:grid-cols-3 grid-cols-1 gap-4  ">
                  {events?.map((event: Event) => (
                    <EventHappeningCard key={event._id} {...event} />
                  ))}
                </div>
              </div>
              <div className="md:hidden flex flex-col gap-4">
                <Carousel
                  responsive={responsive}
                  renderButtonGroupOutside
                  itemClass="px-2.5"
                  arrows={false}
                  shouldResetAutoplay={false}
                >
                  {chunkEvents.map((eventArray, rowIndex) => (
                    <div key={rowIndex} className="flex flex-col gap-4">
                      {eventArray.map((event: Event) => {
                        return (
                          <EventHappeningCard key={event._id} {...event} />
                        );
                      })}
                    </div>
                  ))}
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CurrentlyHappening;
